import React, { useEffect, useRef } from 'react';
import { Toolbar, Grid, Stack, IconButton, Paper, Box, Button } from "@mui/material";
import { LoadingButton } from '@mui/lab';
import ReplayIcon from '@mui/icons-material/Replay';
import { useFormik } from 'formik';
import get from "lodash/get";
import { Formik } from 'formik';
import { useDispatch, useSelector } from "react-redux";
import { exportToExcel } from "react-json-to-excel";
import SearchIcon from '@mui/icons-material/Search';

import AutoComplete from "../../../components/form/AutoComplete";
import DatePickerUi from "../../../components/form/DatePickerUi";
import { getClient } from "../../../store/masters/thunk/client/getAll";
import { getProvider } from "../../../store/masters/thunk/provider/getAll";
import SaveAltIcon from '@mui/icons-material/SaveAlt'; 


const ToolbarComponent = ({ parameters, __, reload, isLoading }) => {
    const dispatch = useDispatch();
    const formikRef = useRef();

    const invoices = useSelector(state => state.reports.invoices);

    const onSubmit = (values) => {
        const body = {
            startDate: get(values,"from"),
            endDate: get(values,"till"),
            idProvider: get(values,"provider"),
            customerId: get(values,"idClient"),
            idStatus: get(values,"idStatus"),
        }
        parameters(body);
        // const Filters = {};

        // if (values.from && values.till) {
        //     Filters.from = values.from;
        //     Filters.till = values.till;

        //     if (values.idClient) {
        //         Filters.ClientId = values.idClient;
        //     } else {
        //         Filters.ClientId = "0";
        //     }
        // }

        // setFilter(Filters)
    }

    // const formik = useFormik({
    //     initialValues: {
    //         from: "",
    //         till: "",
    //         idClient: "",
    //         provider: "",
    //     },
    //     onSubmit,
    // });
    // useEffect(() => {
    //     onSubmit(formik.values)
    // }, [formik.values.from, formik.values.till, formik.values.idClient])

    const initialValues = {
        idClient: "",
        provider: "",
        from: "",
        till: "",
        idStatus: "",
    };

    return (
        <Formik
        innerRef={formikRef}
        initialValues={initialValues} 
        onSubmit={onSubmit} 
        >
            {formik => (
                <Toolbar component={Paper} className='p-2 mb-4' sx={{ borderBottomWidth: "1px", borderBottomColor: "text.sslite", borderBottomStyle: "solid", position: "sticky", top: 0, zIndex: 100 }}>
                    <Stack component="form" onSubmit={get(formik, "handleSubmit")} direction={{ sx: "column", xl: "row" }} alignItems={{ sx: "flex-start", xl: "center" }} justifyContent={{ sx: "center", xl: "space-between" }} spacing={{ sx: 1, xl: 1 }} className='w-full'>
                        <Grid container spacing={1} justifyContent={{ sx: "flex-start", xl: "flex-end" }} alignItems="center">
                            <Grid item xs="auto" justifyContent="flex-end" display="flex">
                                <Button
                                variant="contained"
                                color="success" // El color verde para el botón
                                startIcon={<SaveAltIcon />} // Icono de exportar
                                onClick={() =>  exportToExcel(invoices.data.data, 'Reporte Facturación')}
                                disabled={!invoices?.data.data || invoices.data.data.length === 0}
                                >
                                    Exportar
                                </Button>
                                </Grid>
                        </Grid>
                    </Stack>
                </Toolbar>
            )}
        </Formik> 
    )
}

export default ToolbarComponent